// 一時的なデバッグログ用モジュール（スパイク原因調査用、調査完了後に削除予定）
const MAX_LOG_ENTRIES = 100

const debugLog = []

export const addLog = (entry) => {
  debugLog.push({ ts: Date.now(), ...entry })
  if (debugLog.length > MAX_LOG_ENTRIES) {
    debugLog.shift()
  }
}

// 各エントリを個別の console.log で出力する。
// 1つの長い JSON.stringify だと Chrome が console 出力を切り詰めるため。
export const dumpLog = (label = 'AKADAKO_DEBUG_LOG_DUMP') => {
  console.error(`=== ${label} START (${debugLog.length} entries) ===`)
  for (let i = 0; i < debugLog.length; i++) {
    console.log(`LOG#${i}:`, JSON.stringify(debugLog[i]))
  }
  console.error(`=== ${label} END ===`)
  return debugLog
}

// ブラウザコンソールから手動で叩けるようにグローバルに公開
if (typeof window !== 'undefined') {
  window.__akadakoDumpLog = () => dumpLog('MANUAL_DUMP')
  window.__akadakoDebugLog = debugLog
  // ファイルダウンロード機能（コピペ作業を省くため）
  window.__akadakoDownloadLog = () => {
    const blob = new Blob([JSON.stringify(debugLog, null, 2)], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `akadako-debug-${Date.now()}.json`
    a.click()
    URL.revokeObjectURL(url)
  }
}
